module.exports = __webpack_public_path__ + "static/img/3921_phase_function_Paper_PointsHejduk_Prediction.9d3fcb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3921_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 6dy2
// module chunks = 0